export enum BuildingType {
    HANGAR = 'hangar',
    LABORATORY = 'laboratory',
    RESOURCE = 'resource',
    ENERGY = 'energy',
    STORAGE = 'storage',
    COMMON = 'common',
}
